import { Component, OnInit } from "@angular/core";
import { AppBarTitleService, SsoAccountFacade } from "common";
import { InsuranceService } from "../insurance.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ReminderData, Reminders } from "../../reminder/reminder.model";
import { InsuranceQuoteBaseComponent } from "./insurance-quote-base.component";
import { ReminderService } from "../../reminder/reminder.service";
import { EntityFacade } from "../../entity/domain/+state/entity.facade";

@Component({
    selector: "ifp-insurance-quote-reminder",
    templateUrl: "./insurance-quote.component.html",
    styleUrls: ["./insurance-quote.component.scss"],
    standalone: false
})
export class InsuranceQuoteReminderComponent
  extends InsuranceQuoteBaseComponent<ReminderData>
  implements OnInit
{
  constructor(
    appBarTitleService: AppBarTitleService,
    insuranceService: InsuranceService,
    entityFacade: EntityFacade,
    router: Router,
    reminderService: ReminderService,
    route: ActivatedRoute,
    ssoAccountFacade: SsoAccountFacade
  ) {
    super(
      appBarTitleService,
      insuranceService,
      entityFacade,
      router,
      reminderService,
      route,
      ssoAccountFacade
    );
    this.searchCondition = { name: Reminders.Insurance };
    sessionStorage.setItem("insurancePageViewed", JSON.stringify(true));
  }
}
